import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const groupHeaderStyleId = 'wb-v2-board-group-header-theme';

/**
 * Token bridge for the shared group header. One bridge for both hosts — a Job group row on the table
 * and a Job swimlane on the kanban describe the same thing, so they must read the same.
 */
export const groupHeaderBridgeStyles = {
  'board-group-header': {
    '--local-group-header-title-text': tokens.color.text.primary,
    '--local-group-header-primary-text': tokens.color.text.primary,
    '--local-group-header-secondary-text': tokens.color.text.tertiary,
    '--local-group-header-meta-text': tokens.color.text.tertiary,
    '--local-group-header-sep': tokens.color.text.quaternary,
    '--local-group-header-gap': tokens.spacing.xs,
  },
};
